import { AxiosInstance } from 'axios';
import { storeUser, IUserStorage } from '../../storage/user';
import { IUserCredentials } from '../../user/types';
import { toUserStore } from 'src/services/user/store';

const toLoginPost = ({ username, password }: IUserCredentials) => {
  return [
    `grant_Type=password`,
    `username=${encodeURIComponent(username)}`,
    `Password=${encodeURIComponent(password)}`,
  ].join('&');
};

const fromLoginPost = (
  { username, remember }: IUserCredentials,
  response: any
): IUserStorage => {
  return {
    token: response.access_token,
    refreshToken: response.refresh_token,
    roles: response.userRoles.split(','),
    userId: response.userName,
    username,
    persist: remember,
  };
};

export default (api: AxiosInstance, url: string) => async (
  credentials: IUserCredentials
) => {
  try {
    const response = await api.post(url, toLoginPost(credentials));
    const userStorage = fromLoginPost(credentials, response.data);
    api.defaults.headers.common.Authorization = `Bearer ${userStorage.token}`;
    storeUser(userStorage);
    return toUserStore(userStorage);
  } catch ({ response, message }) {
    throw new Error(response ? response.data.error_description : message);
  }
};



// WEBPACK FOOTER //
// ./src/services/api/user/login.ts